<template>
  <div class="gw-wrapper">
    <div v-if="isRedirectingWallet" class="gw-page-loader">
      <div class="gw-loader-card">
        <div class="gw-spinner"></div>
        <div class="gw-loader-title">Түр хүлээнэ үү...</div>
        <div class="gw-loader-desc">Google Wallet pass үүсгэж байна.</div>
      </div>
    </div>
    <div class="gw-bg-shape gw-bg-shape-left"></div>
    <div class="gw-bg-shape gw-bg-shape-right"></div>

    <div class="gw-card gw-card-login">
      <div class="gw-logo-wrap">
        <img src="@/assets/logo.svg" alt="Номин Карт" class="gw-logo" />
      </div>

      <div class="gw-badge">
        <span class="gw-wallet-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path
              d="M4 7.5C4 6.1 5.1 5 6.5 5H18c1.1 0 2 .9 2 2v1.2h-2V7H6.5c-.3 0-.5.2-.5.5S6.2 8 6.5 8H20c1.1 0 2 .9 2 2v7c0 1.1-.9 2-2 2H5c-1.7 0-3-1.3-3-3V7.5h2Z"
              fill="currentColor"
              opacity=".18"
            />
            <path
              d="M5 8h15c1.1 0 2 .9 2 2v7c0 1.1-.9 2-2 2H5c-1.7 0-3-1.3-3-3V7.5C2 5 4 3 6.5 3H18c1.1 0 2 .9 2 2v2h-2V5H6.5C5.1 5 4 6.1 4 7.5V16c0 .6.4 1 1 1h15v-7H5V8Zm12 5.5c0-.8.7-1.5 1.5-1.5S20 12.7 20 13.5 19.3 15 18.5 15 17 14.3 17 13.5Z"
              fill="currentColor"
            />
          </svg>
        </span>
        Google Wallet холболт
      </div>

      <h1 class="gw-title">
        Google Wallet-д бонус картаа<br />
        нэмэхийн тулд нэвтэрнэ үү.
      </h1>

      <b-alert variant="danger" :show="!!errorMessage" class="gw-alert">
        {{ errorMessage }}
      </b-alert>

      <b-form class="gw-form" @submit.prevent="onSubmit">
        <div class="gw-form-group">
          <label for="gw-username">Нэвтрэх нэр:</label>
          <input
            id="gw-username"
            v-model="username"
            type="text"
            class="gw-input"
            :placeholder="usernamePlaceholder"
            autocomplete="username"
            autofocus
          />
        </div>

        <div class="gw-radio-row">
          <label class="gw-radio">
            <input type="radio" value="phone" v-model="type" />
            <span>Утасны дугаараар</span>
          </label>

          <label class="gw-radio">
            <input type="radio" value="cardId" v-model="type" />
            <span>Картын дугаараар</span>
          </label>
        </div>

        <div class="gw-form-group">
          <label for="gw-password">Нууц үг:</label>

          <div class="gw-password-wrap">
            <input
              id="gw-password"
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              class="gw-input gw-input-with-icon"
              placeholder="Нууц үгээ оруулна уу"
              autocomplete="current-password"
            />

            <button
              type="button"
              class="gw-eye-btn"
              @click="showPassword = !showPassword"
            >
              <span v-if="showPassword">🙈</span>
              <span v-else>👁</span>
            </button>
          </div>
        </div>

        <button
          type="submit"
          class="gw-primary-btn"
          :disabled="isLoading || isRedirectingWallet"
        >
          <span>
            {{
              isLoading || isRedirectingWallet
                ? "Түр хүлээнэ үү..."
                : "Google Wallet-д нэмэх"
            }}
          </span>
          <span class="gw-btn-arrow">→</span>
        </button>
      </b-form>

      <div class="gw-divider"><span>эсвэл</span></div>

      <div class="gw-secondary-row">
        <button
          type="button"
          class="gw-secondary-btn gw-register-btn"
          @click="goSignUp"
        >
          <span class="gw-secondary-icon">♁</span>
          Шинээр бүртгүүлэх
        </button>
      </div>

      <div class="gw-footer-links">
        <a href="#" @click.prevent="showHelp = true">Тусламж</a>
        <span></span>
        <router-link to="/forget">🔒 Нууц үг мартсан?</router-link>
      </div>

      <b-modal v-model="showHelp" title="Тусламж" hide-footer centered>
        <p class="mb-2">
          Номин бонус картын бүртгэлтэй утасны дугаар эсвэл картын дугаараа
          ашиглан нэвтэрнэ үү.
        </p>
        <p class="mb-0">
          Амжилттай нэвтэрсний дараа таны картыг Google Wallet-д нэмэх холбоос
          автоматаар нээгдэнэ.
        </p>
      </b-modal>

      <b-modal
        v-model="showOtpModal"
        title="OTP код баталгаажуулах"
        hide-footer
        centered
        no-close-on-backdrop
        no-close-on-esc
      >
        <div class="gw-otp-modal">
          <p class="gw-otp-desc">
            Таны утсанд ирсэн баталгаажуулах кодыг оруулна уу.
          </p>

          <b-alert variant="danger" :show="!!otpErrorMessage" class="gw-alert">
            {{ otpErrorMessage }}
          </b-alert>

          <b-alert
            variant="success"
            :show="!!otpSuccessMessage"
            class="gw-alert"
          >
            {{ otpSuccessMessage }}
          </b-alert>

          <div class="gw-otp-inputs">
            <input
              v-for="(digit, index) in otpDigits"
              :key="index"
              ref="otpInputs"
              v-model="otpDigits[index]"
              type="text"
              inputmode="numeric"
              maxlength="1"
              class="gw-otp-cell"
              :disabled="isOtpLoading"
              @input="onOtpInput(index)"
              @keydown="onOtpKeydown($event, index)"
              @paste="onOtpPaste"
            />
          </div>

          <button
            type="button"
            class="gw-primary-btn gw-otp-submit"
            :disabled="isOtpLoading || isRedirectingWallet"
            @click="submitOtp"
          >
            {{
              isOtpLoading || isRedirectingWallet
                ? "Шалгаж байна..."
                : "Баталгаажуулах"
            }}
          </button>

          <button
            type="button"
            class="gw-otp-resend-btn"
            :disabled="isOtpLoading || isOtpResending"
            @click="resendOtp"
          >
            {{ isOtpResending ? "Илгээж байна..." : "OTP дахин авах" }}
          </button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

const GOOGLE_WALLET_CREATE_PASS_URL = "loyalty/create/google/wallet/pass";

export default {
  name: "GoogleWalletSignIn",

  data() {
    return {
      username: "",
      password: "",
      type: "phone",
      showPassword: false,
      showHelp: false,
      isLoading: false,
      errorMessage: "",

      isRedirectingWallet: false,

      showOtpModal: false,
      otpDigits: ["", "", "", ""],
      otpErrorMessage: "",
      otpSuccessMessage: "",
      isOtpLoading: false,
      isOtpResending: false,
      otpLoginPayload: null,
    };
  },

  computed: {
    usernamePlaceholder() {
      return this.type === "cardId"
        ? "Картын дугаараа оруулна уу"
        : "Утасны дугаараа оруулна уу";
    },
  },

  methods: {
    validateForm() {
      const username = String(this.username || "").replace(/\s/g, "");
      const password = String(this.password || "").replace(/\s/g, "");

      if (!username || !password) {
        this.errorMessage = "Нэвтрэх нэр болон нууц үгээ оруулна уу.";
        return false;
      }

      if (!/^\d+$/.test(username)) {
        this.errorMessage = "Та зөвхөн тоо оруулна уу.";
        return false;
      }

      this.username = username;
      this.password = password;

      return true;
    },

    async onSubmit() {
      this.errorMessage = "";
      Vue.prototype.globalError = false;

      if (!this.validateForm()) {
        return;
      }

      this.isLoading = true;

      if (this.$insProgress) {
        this.$insProgress.start();
      }

      try {
        const loginResponse = await this.$bonusApi.post(
          "/auth/google/wallet/login",
          {
            cardNumber: this.username,
            password: this.password,
            type: this.type,
            systemId: "GoogleWallet",
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          },
        );

        const loginData = loginResponse.data || {};

        if (
          loginData.success === false &&
          Number(loginData.otpRequired) === 1
        ) {
          this.openOtpModal();
          return;
        }

        if (loginData.success !== true) {
          this.errorMessage = loginData.message || "Нэвтрэхэд алдаа гарлаа.";
          return;
        }

        await this.createCardAndRedirect(loginData, false);
      } catch (error) {
        this.errorMessage = this.getErrorMessage(error);
      } finally {
        this.isLoading = false;

        if (this.$insProgress) {
          this.$insProgress.finish();
        }
      }
    },

    openOtpModal() {
      this.otpLoginPayload = {
        username: this.username,
        password: this.password,
        type: this.type,
        systemId: "GoogleWallet",
      };

      this.otpDigits = ["", "", "", ""];
      this.otpErrorMessage = "";
      this.otpSuccessMessage = "";
      this.showOtpModal = true;

      this.$nextTick(() => {
        if (this.$refs.otpInputs && this.$refs.otpInputs[0]) {
          this.$refs.otpInputs[0].focus();
        }
      });
    },

    onOtpInput(index) {
      let value = this.otpDigits[index] || "";

      value = value.replace(/\D/g, "").slice(0, 1);

      this.$set(this.otpDigits, index, value);

      if (value && index < this.otpDigits.length - 1) {
        this.$nextTick(() => {
          if (this.$refs.otpInputs && this.$refs.otpInputs[index + 1]) {
            this.$refs.otpInputs[index + 1].focus();
          }
        });
      }
    },

    onOtpKeydown(event, index) {
      if (event.key === "Backspace" && !this.otpDigits[index] && index > 0) {
        this.$nextTick(() => {
          if (this.$refs.otpInputs && this.$refs.otpInputs[index - 1]) {
            this.$refs.otpInputs[index - 1].focus();
          }
        });
      }
    },

    onOtpPaste(event) {
      event.preventDefault();

      const pastedValue = event.clipboardData
        .getData("text")
        .replace(/\D/g, "")
        .slice(0, 4);

      pastedValue.split("").forEach((number, index) => {
        this.$set(this.otpDigits, index, number);
      });

      const nextIndex = pastedValue.length >= 4 ? 3 : pastedValue.length;

      this.$nextTick(() => {
        if (this.$refs.otpInputs && this.$refs.otpInputs[nextIndex]) {
          this.$refs.otpInputs[nextIndex].focus();
        }
      });
    },

    async resendOtp() {
      this.otpErrorMessage = "";
      this.otpSuccessMessage = "";

      const payload = this.otpLoginPayload;

      if (!payload || !payload.username) {
        this.otpErrorMessage = "Нэвтрэх мэдээлэл олдсонгүй. Дахин нэвтэрнэ үү.";
        return;
      }

      this.isOtpResending = true;

      if (this.$insProgress) {
        this.$insProgress.start();
      }

      try {
        const isCardId = payload.type === "cardId";
        const isPhone = payload.type === "phone";

        const response = await this.$cardApi.post(
          "/otp/send",
          {
            referenceId: isCardId ? payload.username : "",
            purpose: "LOGIN",
            channel: "SMS",
            receiver: isPhone ? payload.username : "",
            ipAddress: payload.ipAddress || "",
            systemId: "GoogleWallet",
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          },
        );

        const data = response.data || {};

        if (data.success === true || data.status === "SUCCESS") {
          this.otpSuccessMessage = data.message || "OTP код дахин илгээгдлээ.";
        } else {
          this.otpErrorMessage =
            data.message || "OTP дахин илгээхэд алдаа гарлаа.";
        }
      } catch (error) {
        this.otpErrorMessage = this.getErrorMessage(error);
      } finally {
        this.isOtpResending = false;

        if (this.$insProgress) {
          this.$insProgress.finish();
        }
      }
    },

    async submitOtp() {
      this.otpErrorMessage = "";
      this.otpSuccessMessage = "";

      const otp = this.otpDigits.join("");

      if (!otp) {
        this.otpErrorMessage = "OTP код оруулна уу.";
        return;
      }

      if (otp.length < 4) {
        this.otpErrorMessage = "OTP код бүрэн оруулна уу.";
        return;
      }

      if (!/^\d+$/.test(otp)) {
        this.otpErrorMessage = "Та зөвхөн тоо оруулна уу.";
        return;
      }

      const payload = this.otpLoginPayload;

      if (!payload || !payload.username || !payload.password) {
        this.otpErrorMessage = "Нэвтрэх мэдээлэл олдсонгүй. Дахин нэвтэрнэ үү.";
        return;
      }

      this.isOtpLoading = true;

      if (this.$insProgress) {
        this.$insProgress.start();
      }

      try {
        const loginResponse = await this.$bonusApi.post(
          "/auth/google/wallet/login",
          {
            cardNumber: payload.username,
            password: payload.password,
            type: payload.type,
            systemId: "GoogleWallet",
            loginOtp: otp,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          },
        );

        const loginData = loginResponse.data || {};

        if (loginData.success !== true) {
          this.otpErrorMessage = loginData.message || "OTP код буруу байна.";
          return;
        }

        this.showOtpModal = false;

        await this.createCardAndRedirect(loginData, true);
      } catch (error) {
        this.otpErrorMessage = this.getErrorMessage(error);
      } finally {
        this.isOtpLoading = false;

        if (this.$insProgress) {
          this.$insProgress.finish();
        }
      }
    },

    async createCardAndRedirect(loginData, fromOtpModal = false) {
      this.errorMessage = "";
      this.otpErrorMessage = "";
      this.isRedirectingWallet = true;

      const requestBody = this.buildCreateWalletPassRequest(loginData);

      if (!requestBody) {
        this.isRedirectingWallet = false;
        return;
      }

      try {
        const response = await this.$bonusApi.post(
          GOOGLE_WALLET_CREATE_PASS_URL,
          requestBody,
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          },
        );

        const data = response.data || {};

        if (data.success === false) {
          const message =
            data.message || "Google Wallet холболт хийхэд алдаа гарлаа.";

          if (fromOtpModal) {
            this.otpErrorMessage = message;
          } else {
            this.errorMessage = message;
          }

          this.isRedirectingWallet = false;
          return;
        }

        const walletLink = this.extractWalletLink(data);

        if (!walletLink) {
          const message = data.message || "Google Wallet walletLink ирсэнгүй.";

          if (fromOtpModal) {
            this.otpErrorMessage = message;
          } else {
            this.errorMessage = message;
          }

          this.isRedirectingWallet = false;
          return;
        }

        window.location.href = walletLink;
      } catch (error) {
        const message = this.getErrorMessage(error);

        if (fromOtpModal) {
          this.otpErrorMessage = message;
        } else {
          this.errorMessage = message;
        }

        this.isRedirectingWallet = false;
      }
    },

    buildCreateWalletPassRequest(loginData) {
      return {
        cardId: loginData.phoneNumber,
      };
    },

    extractWalletLink(data) {
      if (!data) {
        return "";
      }

      if (typeof data === "string") {
        return data.indexOf("http") === 0 ? data : "";
      }

      return (
        data.walletLink ||
        data.walletlink ||
        data.url ||
        data.link ||
        (data.data &&
          (data.data.walletLink ||
            data.data.walletlink ||
            data.data.url ||
            data.data.link)) ||
        ""
      );
    },

    getErrorMessage(error) {
      if (error && error.response && error.response.data) {
        const data = error.response.data;

        return (
          data.message ||
          data.error ||
          "Google Wallet холболт хийхэд алдаа гарлаа."
        );
      }

      return (
        (error && error.message) || "Google Wallet холболт хийхэд алдаа гарлаа."
      );
    },

    goSignUp() {
      this.$router.push({
        path: "/google-wallet/sign-up",
        query: this.$route.query,
      });
    },
  },
};
</script>

<style scoped>
.gw-wrapper {
  background-image: linear-gradient(
    to bottom,
    #5192d4,
    #4984c6,
    #4275b8,
    #3b68a9,
    #345a9b
  );
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  padding: 20px;
  font-family: "Roboto", Arial, sans-serif;
}

.gw-bg-shape {
  display: none;
}

.gw-card {
  width: 396px;
  min-height: 560px;
  border-radius: 10px;
  box-shadow: 0px 25px 59px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  padding: 58px 58px 28px;
  position: relative;
  z-index: 1;
}

.gw-card-login {
  max-width: 396px;
}

.gw-logo-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.gw-logo {
  width: 250px;
  height: 32px;
  object-fit: contain;
}

.gw-badge {
  margin: 0 auto 18px;
  width: max-content;
  max-width: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 999px;
  color: #1660ab;
  background: #eef5fb;
  font-weight: 500;
  font-size: 11px;
}

.gw-wallet-icon {
  display: inline-flex;
  color: #1660ab;
}

.gw-wallet-icon svg {
  width: 14px;
  height: 14px;
}

.gw-title {
  margin: 0 0 24px;
  text-align: center;
  color: #202a3a;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.45;
}

.gw-alert {
  border-radius: 5px;
  font-size: 11px;
  padding: 8px 10px;
  margin-bottom: 12px;
}

.gw-form-group {
  margin-bottom: 14px;
}

.gw-form-group label {
  width: 100%;
  height: auto;
  font-family: "Roboto", Arial, sans-serif;
  font-size: 11px;
  margin-bottom: 8px;
  font-weight: bold;
  font-style: normal;
  letter-spacing: 0.3px;
  text-align: left;
  color: #000000;
  text-transform: uppercase;
  display: block;
}

.gw-input {
  height: 36px;
  border-radius: 5px;
  font-size: 13px;
  width: 280px;
  max-width: 100%;
  background-color: #f5f5f5;
  border: 1px solid #ced4da;
  padding: 6px 12px;
  outline: none;
  color: #273142;
}

.gw-input:focus {
  border-color: #1660ab;
  box-shadow: none;
}

.gw-input::placeholder {
  opacity: 0.5;
  font-family: "Roboto", Arial, sans-serif;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.5);
}

.gw-radio-row {
  margin-top: 6px;
  margin-bottom: 18px;
  display: flex;
  gap: 18px;
  flex-wrap: nowrap;
}

.gw-radio {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 10px;
  color: #000000;
  margin: 0;
  white-space: nowrap;
}

.gw-radio input {
  width: 20px;
  height: 20px;
  accent-color: #1660ab;
  margin: 0;
}

.gw-password-wrap {
  position: relative;
  width: 280px;
  max-width: 100%;
}

.gw-input-with-icon {
  width: 280px;
  padding-right: 38px;
}

.gw-eye-btn {
  position: absolute;
  right: 9px;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: #8a94a6;
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
  padding: 0;
}

.gw-primary-btn {
  width: 280px;
  height: 36px;
  margin-top: 24px;
  border: none;
  border-radius: 5px;
  background-color: #1660ab;
  font-family: "Roboto", Arial, sans-serif;
  font-size: 13px;
  font-weight: normal;
  letter-spacing: 0.3px;
  text-align: center;
  color: #ffffff;
  text-transform: uppercase;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  transition: background 0.2s ease;
}

.gw-primary-btn:hover:not(:disabled) {
  background: #0e5196;
}

.gw-primary-btn:disabled {
  opacity: 0.72;
  cursor: not-allowed;
}

.gw-btn-arrow {
  display: none;
}

.gw-primary-btn span:first-child {
  margin: 0;
  padding: 0;
}

.gw-divider {
  display: none;
}

.gw-secondary-row {
  margin-top: 10px;
  width: 280px;
  display: flex;
  gap: 5px;
  align-items: center;
}

.gw-secondary-btn {
  border: none;
  border-radius: 4px;
  padding: 4px 6px;
  min-height: 30px;
  height: 30px;
  font-family: "Roboto", Arial, sans-serif;
  font-size: 11px;
  font-weight: normal;
  text-transform: uppercase;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  line-height: 1.1;
}

.gw-register-btn {
  flex: 1;
  background-color: #f7941d;
  color: #ffffff;
  border: none;
}

.gw-register-btn:hover {
  background: #000000;
  color: #ffffff;
}

.gw-secondary-icon {
  display: none;
}

.gw-footer-links {
  width: 280px;
  margin-top: 17px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  align-items: center;
}

.gw-footer-links span {
  display: none;
}

.gw-footer-links a {
  font-family: "Roboto", Arial, sans-serif;
  font-size: 11px;
  font-weight: normal;
  color: #1660ab;
  cursor: pointer;
  text-decoration: none;
}

.gw-footer-links a:first-child {
  text-align: left;
}

.gw-footer-links a:last-child {
  text-align: right;
}

.gw-footer-links a:hover {
  color: #000000;
}

.gw-otp-modal {
  text-align: center;
}

.gw-otp-desc {
  margin-bottom: 18px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}

.gw-otp-inputs {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin: 18px 0 20px;
}

.gw-otp-cell {
  width: 48px;
  height: 42px;
  border-radius: 5px;
  background-color: #f5f5f5;
  border: 1px solid #ced4da;
  text-align: center;
  font-family: "Roboto", Arial, sans-serif;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}

.gw-otp-cell:focus {
  outline: none;
  border-color: #1660ab;
  background-color: #ffffff;
}

.gw-otp-cell:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.gw-otp-submit {
  width: 100%;
  margin-top: 0;
}

.gw-otp-resend-btn {
  margin-top: 12px;
  border: none;
  background: transparent;
  color: #1660ab;
  font-size: 12px;
  cursor: pointer;
}

.gw-otp-resend-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.gw-page-loader {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(255, 255, 255, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
}

.gw-loader-card {
  width: 260px;
  min-height: 150px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 24px;
  text-align: center;
}

.gw-spinner {
  width: 34px;
  height: 34px;
  border: 3px solid #d8e8f7;
  border-top-color: #1660ab;
  border-radius: 50%;
  animation: gw-spin 0.8s linear infinite;
}

.gw-loader-title {
  font-size: 14px;
  font-weight: 700;
  color: #202a3a;
}

.gw-loader-desc {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
}

@keyframes gw-spin {
  to {
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 400px) {
  .gw-wrapper {
    padding: 12px;
  }

  .gw-card {
    width: 300px;
    max-width: 300px;
    padding-left: 25px;
    padding-right: 25px;
  }

  .gw-logo {
    width: 230px;
  }

  .gw-input,
  .gw-password-wrap,
  .gw-input-with-icon,
  .gw-primary-btn,
  .gw-secondary-row,
  .gw-footer-links {
    width: 100%;
  }

  .gw-radio-row {
    gap: 12px;
  }

  .gw-radio {
    font-size: 9px;
  }

  .gw-secondary-row {
    flex-direction: column;
  }

  .gw-secondary-btn {
    width: 100%;
  }

  .gw-footer-links {
    grid-template-columns: 1fr;
  }

  .gw-footer-links a,
  .gw-footer-links a:first-child,
  .gw-footer-links a:last-child {
    text-align: left;
  }

  .gw-otp-inputs {
    gap: 8px;
  }

  .gw-otp-cell {
    width: 44px;
  }
}
</style>
